import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eef1c260")

_pushScopeId("data-v-eef1c260")
const _hoisted_1 = { class: "mb-2 rounded" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm",
  "data-testid": "guide-message"
}
const _hoisted_4 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_5 = {
  class: "",
  "data-testid": "results-message"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "mt-2 text-xs" }, " Select one of the grades above, or press N, U, F, G or E on your keyboard ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gradeItems, (gradeItem, index) => {
        return (_openBlock(), _createBlock("button", {
          class: ["flex items-center mr-2 border-2 border-transparent rounded opacity-50 focus:outline-none", {
          'hover:opacity-100': !_ctx.disabled,
          'cursor-default': _ctx.disabled
        }],
          disabled: _ctx.disabled,
          onClick: ($event: any) => (_ctx.handleGradeSelected(gradeItem)),
          key: index,
          "data-testid": `grade-item-${index}`
        }, [
          _createVNode(_component_icon_component, {
            class: "w-12 h-12 text-purple-600 stroke-current",
            icon: gradeItem.icon,
            "data-testid": `grade-item-${gradeItem.grade}`
          }, null, 8, ["icon", "data-testid"])
        ], 10, ["disabled", "onClick", "data-testid"]))
      }), 128))
    ]),
    (_ctx.disabled)
      ? (_openBlock(), _createBlock("div", _hoisted_3, " Select maneuvers to start grading "))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.numSelected) + " " + _toDisplayString(_ctx.numSelected === 1 ? 'item selected' : 'items selected') + " ", 1),
            _createVNode("span", {
              class: "text-blue-500 cursor-pointer hover:underline",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClearSelected && _ctx.handleClearSelected(...args))),
              "data-testid": "clear-selected-button"
            }, "Deselect Cells")
          ]),
          _hoisted_6
        ]))
  ]))
})